import { IonContent, IonPage } from '@ionic/react';
import { Flex, Text } from '@servicetitan/anvil2';

export const OnboardingRequiredPage = () => {
    return (
        <IonPage>
            <IonContent>
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    style={{ height: '100%', padding: '24px' }}
                >
                    <Flex
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        style={{ maxWidth: '445px' }}
                    >
                        <Text
                            variant="headline"
                            el="h1"
                            size="large"
                            style={{ marginBlockEnd: '16px', textAlign: 'center' }}
                        >
                            Complete Your Fleet Pro Setup
                        </Text>
                        <Text variant="body" style={{ textAlign: 'center' }}>
                            Before you can use Fleet Pro on your mobile device, please complete the
                            onboarding process in the desktop application. Once setup is complete,
                            return here to access all Fleet Pro features.
                        </Text>
                    </Flex>
                </Flex>
            </IonContent>
        </IonPage>
    );
};

